module.exports = __webpack_public_path__ + "static/media/track-utah.9a67f9b3.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-utah.png
// module id = 1040
// module chunks = 0